import React from 'react';
import { Box, BoxProps } from '../box';
type Props = BoxProps & Omit<JSX.IntrinsicElements['label'], 'ref'>;
export type LabelProps = Props;
export const Label = (props: Props) => <Box as="label" {...props} data-sentry-element="Box" data-sentry-component="Label" data-sentry-source-file="Label.tsx" />;